module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "after-picassos-sleeping-peasants"
    }
  }, [_c('h1', [_vm._v("After Picasso’s Sleeping Peasants")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "5em"
    }
  }, [_vm._v("They sleep on shafts of grain, detached, Though his firm hand lays its red touch On her restfully upraised arm.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "5em"
    }
  }, [_vm._v("He shades himself from the high sun With the straw hat of the sower.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "5em"
    }
  }, [_vm._v("His hard-edged elbow embedded In hay carves its niche like a plow.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "5em"
    }
  }, [_vm._v("She opens herself to the sun, Opens the green vale of her skirt,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "5em"
    }
  }, [_vm._v("Opens the cream clouds of her shirt, Opens the two-petaled flower")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "5em"
    }
  }, [_vm._v("Of her small mouth to the high sun.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "5em"
    }
  }, [_vm._v("Pure and intact, they dream paused dreams At peace in the creative act.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 78
// module chunks = 0